/**
 * أسماءُ العرض في تطبيق الإدارة — <b>ومجالُها الإدارةُ وحدَها</b>.
 *
 * وصياغةُ الأرقام والتواريخ ليست هنا: هي في <c>@shop/shared</c> لأنّ الثلاثةَ
 * تحتاجها (الموقعُ العامُّ يحتاج الاسمَ، ونقطةُ البيع تحتاج المال والكميّة).
 * وحالاتُ المسوّدة ومصادرُ الإدخال تخصّ شاشاتِ الإدارة، فبقيت معها.
 *
 * <b>وتُعاد الصياغةُ العامّةُ من هنا</b>: للشاشة بابُ استيرادٍ واحدٌ لكلّ ما
 * يخصّ العرض. والسطرُ أدناه هو الحدُّ نفسُه مكتوبًا — ما فوقه مجالٌ، وما تحته
 * مشترَك.
 */

export { formatMoney, formatMoment, formatQty, toNumber } from '@shop/shared'

/** أسماءُ حالات المسوّدة بالعربيّة — الرمزُ عقدٌ والنصُّ عرض. */
export const draftStatusNames: Record<string, string> = {
  DRAFT: 'مسوّدة',
  PENDING_REVIEW: 'تنتظر المراجعة',
  CONFIRMED: 'اعتُمدت — صنفٌ جديد',
  MERGED: 'اعتُمدت — رُبطت بصنفٍ قائم',
  REJECTED: 'مرفوضة',
}

/** الحالاتُ النهائيّة كما يعرفها الخادم (`DraftStatuses.IsFinal`). */
export function isFinalStatus(status: string) {
  return status === 'CONFIRMED' || status === 'MERGED' || status === 'REJECTED'
}

export const sourceNames: Record<string, string> = {
  VOICE: 'إملاء',
  BARCODE: 'ماسح',
  OCR: 'صورة',
  MANUAL: 'يدويّ',
}

export function draftStatusName(code: string) {
  return draftStatusNames[code] ?? code
}

export function sourceName(code: string) {
  return sourceNames[code] ?? code
}
